import { Icon, type IconProps } from '@chakra-ui/react';

/**
 * Microsoft four-square brand mark. Fixed brand hex values per Microsoft's
 * brand guidelines — sanctioned exception to the no-hardcoded-colour rule
 * (brand marks only).
 */
export function MicrosoftLogo(props: IconProps) {
  return (
    <Icon viewBox="0 0 21 21" aria-hidden {...props}>
      <rect x="1" y="1" width="9" height="9" fill="#F25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
      <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
      <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </Icon>
  );
}
